import React from 'react';
import { logApiCall } from '../utils/logger';

const API_URL = process.env.REACT_APP_API_URL;

const ContextMenu = ({ x, y, onComplete, onUncomplete, onClose, isCompleted, taskId }) => {
    return (
        <div 
            style={{ 
                position: 'fixed', 
                top: `${y}px`, 
                left: `${x}px`, 
                zIndex: 1000 
            }}
            className="bg-white border border-gray-200 rounded shadow-lg"
        >
            <ul>
                {isCompleted ? (
                    <li 
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={async () => {
                            try {
                                logApiCall('PUT', `${API_URL}/tasks/${taskId}/uncomplete`);
                                await fetch(`${API_URL}/tasks/${taskId}/uncomplete`, { method: 'PUT' });
                                onUncomplete(taskId);
                                onClose();
                            } catch (error) {
                                console.error('Error uncompleting task:', error);
                            }
                        }}
                    >
                        Uncomplete
                    </li>
                ) : (
                    <li 
                        className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        onClick={async () => {
                            try {
                                logApiCall('PUT', `${API_URL}/tasks/${taskId}/complete`);
                                await fetch(`${API_URL}/tasks/${taskId}/complete`, { method: 'PUT' });
                                onComplete(taskId);
                                onClose();
                            } catch (error) {
                                console.error('Error completing task:', error);
                            }
                        }}
                    >
                        Complete
                    </li>
                )}
            </ul>
        </div>
    );
};

export default ContextMenu;